export default {
  editMode: false,
  loading: false,
  data: null,
};
